<template>
  <div class = 'box' :class = '{"vertical-box": isVertical}'>
    <div class = 'label'>
      <span v-if = 'fieldData.isRequired' style = 'color:red;'>*</span>
      {{fieldData.fieldName}}
      <CIcon v-if = 'fieldData.fieldHint' color = '#04cbd8' size = '12' :tip = 'fieldData.fieldHint' delay = '200' icon = 'zhuangtai-bangzhu' />
    </div>
    <div v-if = 'isPreview||(!fieldData.writeable)' class = 'content-auto-height' :class = '{"ivu-form-item-error":verifyTxt}'>
      <div v-if = "fieldData.fieldType == 8||fieldData.fieldCname == 'tel_number'" style = 'line-height:32px;'>{{fieldData.__value__key__ | filterSens}}</div>
      <CFileField v-else-if = 'fieldData.fieldType == "16"' :ids = "fieldData.value" />
      <div v-else-if = 'fieldData.fieldType == "15"'>
        <CImgPreview :key = 'index' v-for = '(item,index) in fieldData.value.split(",")' v-show = "item" style = 'width:45px;height:45px;margin-right:5px;' :src = '`${envConst["API_BASE_URL"]}/file/filemanage/downloadFileByIdAndName/${item}?renameFileName=${new Date().getTime()}-${index+1}`' />
      </div>
       <div v-else-if = "fieldData.fieldCname == 'cust_phone'||fieldData.fieldCname == 'cust_name'" style = 'line-height:32px;'>
        <DoubleCall :fieldData='fieldData' :doubleCallFlag='doubleCallFlag' :allFieldsVal='allFieldsVal'/>
      </div>
      <div v-else style = 'line-height:32px;'>{{fieldData.__value__key__}}</div>
      
    </div>
    <div v-else-if = 'auoHeight || isVertical' class = 'content-auto-height' :class = '{"ivu-form-item-error":verifyTxt}'>
      <slot></slot>
      <div style = "color:red;font-size:12px;">{{verifyTxt}}</div>
    </div>
    <div v-else class = 'content-auto-height' :class = '{"ivu-form-item-error":verifyTxt}'>
      <slot></slot>
      <div style = "color:red;font-size:12px;">{{verifyTxt}}</div>
    </div>
  </div>
</template>

<script>
import { fieldInitRe } from './fieldType'
import DoubleCall from './mdwfCompUtil/doubleCall.vue'
import envConst from '@/env-const.js'
export default {
  props: [
    'fieldData',
    'auoHeight',
    'isPreview',
    'isVertical',
    'doubleCallFlag',
    'allFieldsVal'
  ],
  components:{
    DoubleCall
  },
  watch:{
    'fieldData.value': {
      handler(newValue){
        // console.log(newValue)
        this.verify(this.fieldData)
      }
    }
  },
  computed: {
    imgFields(){
      var arr = []
      if(this.fieldData.fieldType == '15'){
        console.log('图片',this.fieldData)
        let {value} = this.fieldData
        if(value){
          for(let i in value){
            if(value[i]){
              arr.push(value[i])
            }
          }
          return arr.join(',')
        }
        
      }else{
        return arr
      }
    }
  },
  created(){
    this.envConst = envConst || {}
  },
  data(){
    return {
      envConst: {},
      verifyTxt: '',
      isRequired: false
    }
  },
  methods: {
    //字段校验
    verify(){
      let verifyTxt = ''
      let { value,maxLength,minLength,minimumUpload,isRequired,fieldType,fieldName } = this.fieldData
      if(value&&!this.verifyByFieldType(this.fieldData,value)){
        verifyTxt = `${fieldName}格式错误`
      }
      if(isRequired){
        if(!value){
          verifyTxt = `${fieldName}不能为空`
        }
      }
      if(maxLength&&value&&value.length&&value.length>maxLength){
        verifyTxt = `${fieldName}长度不能大于${maxLength}`
      }
      if(minLength&&value&&value.length&&value.length<minLength){
        verifyTxt = `${fieldName}长度不能小于${minLength}`
      }
      this.verifyTxt = verifyTxt
      if(this.isPreview|| this.fieldData.isShow != 1){
        return ''
      }else{
        return verifyTxt
      }
      
    },
    verifyByFieldType(fieldType,value){
      let re = fieldInitRe(fieldType)
      if(re){
        return re.test(value)
      }
      return true
    },
    _reset(){
      this.verifyTxt = ''
    }
  }
}
</script>

<style scoped lang = "less">
.vertical-box{
  display:block!important;
  .label{
    width:100%!important;
  }
}
.box{
  display:flex;
  padding-bottom:20px;
  .label{
    width:100px;
    line-height:32px;
  }
  .content{
    flex:1;
    height:32px;
    box-sizing: border-box;
    /* border:1px solid red; */
    border-radius: 4px;
  }
  .content-auto-height{
    flex:1;
    height:auto;
    box-sizing: border-box;
    /* border:1px solid red; */
    border-radius: 4px;
  }
}
</style>